// dataUtils.js

/* eslint-disable no-unused-vars */

import { formatDecimal } from "./numberUtils.js";

export function initializeData(vm) {
  // Set default values for Table 1
  vm.fieldName = vm.internalDict.fieldName;
  vm.fieldLocation = vm.internalDict.fieldLocation;
  vm.cropSelected = vm.cropOptions[vm.internalDict.cropSelected];
  vm.irrigationSelected =
    vm.irrigationOptions[vm.internalDict.irrigationSelected];

  // Set default values for Table 2
  vm.irrigatedArea = vm.internalDict.irrigatedArea;
  vm.daysPerSeason = vm.internalDict.daysPerSeason;
  vm.flowRate = vm.internalDict.flowRate;
  vm.pumpPressure = vm.internalDict.pumpPressure;
  vm.pumpEfficiency = vm.internalDict.pumpEfficiency;
  vm.hoursPerSeason = vm.internalDict.hoursPerSeason;
  // vm.grossInchesSeason = formatDecimal(vm.flowRate * vm.hoursPerSeason / (453 * vm.irrigatedArea));
  // vm.brakingHP = formatDecimal(vm.flowRate * vm.pumpPressure / 1717 / (vm.pumpEfficiency / 100));

  // Set default values for Table 3
  vm.motorEfficiency = vm.internalDict.motorEfficiency;
  // vm.motorCapacity = formatDecimal(vm.brakingHP / (vm.motorEfficiency / 100) * 0.74569987);
  // vm.totalKWH = formatDecimal(vm.motorCapacity * vm.hoursPerSeason);
  vm.energyCharge = vm.internalDict.energyCharge;
  vm.customerCharge = vm.internalDict.customerCharge;
  vm.demandCharge = vm.internalDict.demandCharge;
  vm.riderB = vm.internalDict.riderB;
  vm.riderG = vm.internalDict.riderG;
  vm.riderJ = vm.internalDict.riderJ;
  vm.adminFee = vm.internalDict.adminFee;
  vm.rebateProg = vm.internalDict.rebateProg;

  // Table 4= Natural Gas
  vm.ngEngineEfficiency = vm.internalDict.ngEngineEfficiency;
  //vm.ngHPRequired = vm.brakingHP;
  //vm.ngTotalGJ = formatDecimal(vm.ngHPRequired * vm.hoursPerSeason * 0.0026845 / (vm.ngEngineEfficiency / 100.));
  vm.ngGasPrice = vm.internalDict.ngGasPrice;
  vm.ngFixedDelivery = vm.internalDict.ngFixedDelivery;
  vm.ngVariableDelivery = vm.internalDict.ngVariableDelivery;
  vm.ngRiderL = vm.internalDict.ngRiderL;
  vm.ngAdminFee = vm.internalDict.ngAdminFee;
  vm.ngRebateProg = vm.internalDict.ngRebateProg;

  // Table 5= Diesel
  //Diesel Engine Fuel Consumption Rating
  vm.dieselFuelRating_lbPerHPH = vm.internalDict.dieselFuelRating_lbPerHPH;
  //convert lb to liter
  //vm.dieselFuelRating_literPerHPH = formatDecimal(vm.dieselFuelRating_lbPerHPH * 450 / 860.);
  //vm.dieselEngineRequired = vm.brakingHP;
  // vm.dieselTotalLitre = formatDecimal(vm.dieselFuelRating_literPerHPH * vm.brakingHP * vm.hoursPerSeason)
  vm.dieselPrice = vm.internalDict.dieselPrice;
  vm.dieselRebateProg = vm.internalDict.dieselRebateProg;

  // Table 6= Propane
  vm.propaneEngineEfficiency = vm.internalDict.propaneEngineEfficiency;
  //copied over
  //vm.propaneHPRequired = vm.brakingHP;
  //vm.propaneTotalConsumption = formatDecimal(0.0026845195376962 * vm.propaneHPRequired * vm.hoursPerSeason / (vm.propaneEngineEfficiency / 100) * 39.072);
  vm.propanePrice = vm.internalDict.propanePrice;
  vm.propaneRebate = vm.internalDict.propaneRebate;

  // Set the default last updated date
  //The Date constructor in JavaScript takes the month as a zero-based index,
  //where January is represented by 0 and December is represented by 11
  //const defaultLastUpdatedDate = new Date(2023, 8, 7);

  //months in JavaScript's Date object are 0-indexed
  //vm.lastUpdatedDate = defaultLastUpdatedDate.toLocaleDateString();
  vm.lastUpdatedDate = vm.internalDict.lastUpdatedDate;

  //no change below this line
  //==============================================================

  // Comparison Table
  vm.electricityCost = 0;
  vm.electricityCostPerAcre = 0;
  vm.electricityCostPerInch = 0;
  vm.electricityCostPerAcreInch = 0;
  vm.electricityCostPerHpHr = 0;
  vm.electricityUsage = 0;
  vm.electricityCostPerUnit = 0;

  vm.ngCost = 0;
  vm.ngCostPerAcre = 0;
  vm.ngCostPerInch = 0;
  vm.ngCostPerAcreInch = 0;
  vm.ngCostPerHpHr = 0;
  vm.ngUsage = 0;
  vm.ngCostPerUnit = 0;

  vm.dieselCost = 0;
  vm.dieselCostPerAcre = 0;
  vm.dieselCostPerInch = 0;
  vm.dieselCostPerAcreInch = 0;
  vm.dieselCostPerHpHr = 0;
  vm.dieselUsage = 0;
  vm.dieselCostPerUnit = 0;

  vm.propaneCost = 0;
  vm.propaneCostPerAcre = 0;
  vm.propaneCostPerInch = 0;
  vm.propaneCostPerAcreInch = 0;
  vm.propaneCostPerHpHr = 0;
  vm.propaneUsage = 0;
  vm.propaneCostPerUnit = 0;

  vm.defaultValues = {
    irrigatedArea: vm.irrigatedArea,
    daysPerSeason: vm.daysPerSeason,
    flowRate: vm.flowRate,
    pumpPressure: vm.pumpPressure,
    pumpEfficiency: vm.pumpEfficiency,
    hoursPerSeason: vm.hoursPerSeason,
    grossInchesSeason: vm.grossInchesSeason,
    brakingHP: vm.brakingHP,

    motorEfficiency: vm.motorEfficiency,
    motorCapacity: vm.motorCapacity,
    totalKWH: vm.totalKWH,
    energyCharge: vm.energyCharge,
    customerCharge: vm.customerCharge,
    demandCharge: vm.demandCharge,
    riderB: vm.riderB,
    riderG: vm.riderG,
    riderJ: vm.riderJ,
    adminFee: vm.adminFee,
    rebateProg: vm.rebateProg,

    ngEngineEfficiency: vm.ngEngineEfficiency,
    ngGasPrice: vm.ngGasPrice,
    ngFixedDelivery: vm.ngFixedDelivery,
    ngVariableDelivery: vm.ngVariableDelivery,
    ngRiderL: vm.ngRiderL,
    ngAdminFee: vm.ngAdminFee,
    ngRebateProg: vm.ngRebateProg,

    dieselFuelRating_lbPerHPH: vm.dieselFuelRating_lbPerHPH,
    dieselPrice: vm.dieselPrice,
    dieselRebateProg: vm.dieselRebateProg,

    propaneEngineEfficiency: vm.propaneEngineEfficiency,
    propanePrice: vm.propanePrice,
    propaneRebate: vm.propaneRebate,

    lastUpdatedDate: vm.lastUpdatedDate,
  };

   // Add console.log statements to log variable values
  //console.log("irrigatedArea:", vm.internalDict.irrigatedArea);

  //console.log("internalDict:", vm.internalDict);
  //console.log("internalDict:", vm.linkDict);
  //console.log("date:", vm.internalDict.lastUpdatedDate);
}
